type TNamedItem = { id: string, name: string };

type TNameClashOutcome = {
  name?: string,
  isUnresolved?: boolean,
};

export const toKeepBothName = (name: string, takenNames: string[]) => {
  const extension = name.lastIndexOf('.') > 0 ? name.slice(name.lastIndexOf('.')) : '';
  const baseName = name.slice(0, name.length - extension.length);
  const taken = new Set(takenNames);

  const toCopyName = (copyNumber: number): string => {
    const copyName = `${baseName} (${copyNumber})${extension}`;
    return taken.has(copyName) ? toCopyName(copyNumber + 1) : copyName;
  };
  return toCopyName(1);
};

export const findNameClash = (item: TNamedItem, siblings: TNamedItem[]) => {
  return siblings.find((sibling) => sibling.name === item.name && sibling.id !== item.id);
};

export const resolveNameClash = (
  item: TNamedItem,
  siblings: TNamedItem[],
  keepBoth?: boolean,
): TNameClashOutcome => {
  const clashingSibling = findNameClash(item, siblings);
  if (!clashingSibling) {
    return {};
  }
  if (keepBoth) {
    const takenNames = siblings.map((sibling) => sibling.name);
    return { name: toKeepBothName(item.name, takenNames) };
  }
  return { isUnresolved: true };
};
